import { render, staticRenderFns } from "./Screening2.vue?vue&type=template&id=f8e232ee&"
import script from "./Screening2.vue?vue&type=script&lang=js&"
export * from "./Screening2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports